import { TractieDialogProps } from "@tractie/components/custom-elements";
import { RefObject, PropsWithChildren } from "react";

export interface ToggleableElement extends HTMLElement {
  /** Shows or hides the container.
   *  @param open If true, the container will be displayed; if false, the container will be hidden.
   */
  toggleContainer(open: boolean): void;
}

export interface ToggleableDialogProps
  extends Readonly<TractieDialogProps>, Readonly<PropsWithChildren> {
  readonly dialogRef: RefObject<ToggleableElement | null>;
}

/** Dialog that can be shown and hidden separate from its containing component.
 * Used e.g. to hide the containing component while still showing the dialog.
 */
export function ToggleableDialog({
  dialogRef,
  children,
  ...props
}: ToggleableDialogProps): React.JSX.Element {
  return (
    <tractie-dialog ref={dialogRef} {...props}>
      {children}
    </tractie-dialog>
  );
}
